type ConfirmReason = "EXPIRED" | "COMPLETED";

interface ConfirmExpireModalProps {
    open: boolean;
    tradeId?: number;
    reason: ConfirmReason;
    onConfirm: () => void;
    onCancel: () => void;
    loading?: boolean;
}
const ConfirmExpireModal = ({
    open,
    tradeId,
    reason,
    onConfirm,
    onCancel,
    loading = false,
}: ConfirmExpireModalProps) => {
    if (!open) return null;

    const isExpired = reason === "EXPIRED";

    return (
        <div className="fixed inset-0 z-[100000]">
            {/* 🌑 BACKDROP */}
            <div
                className="fixed inset-0 bg-black/50"
                onClick={!loading ? onCancel : undefined}
            />

            <div className="fixed inset-0 flex items-center justify-center pointer-events-none">
                <div className="relative pointer-events-auto bg-[#ffffff] border-[5px] border-border-table rounded-lg shadow-2xl w-[360px] p-4">

                    {/* ❌ CLOSE */}
                    <button
                        onClick={onCancel}
                        disabled={loading}
                        className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 disabled:opacity-50"
                    >
                        <span className="material-symbols-outlined text-[18px]">
                            close
                        </span>
                    </button>

                    <h2 className="text-sm font-semibold mb-2">
                        {isExpired ? "Confirm Re-Expiry" : "Confirm Expiry"}
                    </h2>

                    <p className="text-xs text-gray-600 mb-4">
                        Trade <strong>{tradeId}</strong>{" "}
                        {isExpired ? (
                            <>
                                is already <strong>expired</strong>.
                                <br />
                                Do you want to expire it again?
                            </>
                        ) : (
                            <>
                                is already <strong>completed</strong>.
                               
                                Are you sure you want to continue?
                            </>
                        )}
                    </p>

                    <div className="flex justify-end gap-2">
                        <button
                            onClick={onCancel}
                            disabled={loading}
                            className="px-3 py-1 text-xs rounded bg-bg-base disabled:opacity-50"
                        >
                            Cancel
                        </button>

                        <button
                            onClick={onConfirm}
                            disabled={loading}
                            className="px-3 py-1 text-xs rounded bg-bg-button-delete text-[#ffffff]
                         flex items-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
                        >
                            {loading && (
                                <span className="animate-spin rounded-full h-3 w-3 border-2 border-white border-t-transparent" />
                            )}
                            {loading ? "EXPIRING" : "Confirm"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmExpireModal;
